import React from 'react'
import { INCOME_QUARTERLY_ITEM_DETAIL } from '../urls'
import { usePutRequest } from '../hooks/request'
import ServerError from './componentsFinance/common/ServerError'
import IncomeQuarterlyItemForm from './IncomeQuarterlyItemForm'

export default function IncomeQuarterlyItemUpdate({ onCancel, onSuccess, reportItem, finance, incomeQuarterlyId }) {
    const url = INCOME_QUARTERLY_ITEM_DETAIL.replace('{id}', reportItem.id)
    const incomeQuarterlyItemUpdate = usePutRequest({ url })

    async function onSubmit(data) {
        const { success } = await incomeQuarterlyItemUpdate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <b>Изменить данные</b><br /><br />
            <ServerError error={incomeQuarterlyItemUpdate.error} />
            <IncomeQuarterlyItemForm
                initialValues={reportItem}
                onSubmit={onSubmit}
                onCancel={onCancel}
                incomeQuarterlyId={incomeQuarterlyId}
                finance={finance}
                loading={incomeQuarterlyItemUpdate.loading} />
        </div>
    )
}
